import * as React from 'react';
import Tooltip from 'src/components/tooltip';
import Icon from 'src/components/icon';
import { Loading } from 'src/components/loading';
import {
  PRO_USER_MAX_IMAGE_SIZE_STRING,
  PRO_USER_MAX_IMAGE_SIZE_BYTES,
  PRO_USER_MAX_VIDEO_SIZE_BYTES,
  PRO_USER_MAX_VIDEO_SIZE_STRING,
} from 'src/helpers/images';
import { MediaLabel, MediaInput, Form } from './style';

class MediaUploader extends React.Component {
  form;

  validate = (validity, file) => {
    const { currentUser } = this.props;
    // if (!currentUser) return 'You must be signed in to upload images';
    if (!file) return this.props.onError('You should upload valid file');
    if (!validity.valid)
      return "We couldn't validate this upload, please try uploading another file";
    if (
      file &&
      file.type === 'video/mp4' &&
      file.size > PRO_USER_MAX_VIDEO_SIZE_BYTES
    ) {
      return `Video size can not be larger than ${PRO_USER_MAX_VIDEO_SIZE_STRING}.`;
    }
    if (
      file &&
      file.type !== 'video/mp4' &&
      file.size > PRO_USER_MAX_IMAGE_SIZE_BYTES
    ) {
      return `Image size can not be larger than  ${PRO_USER_MAX_IMAGE_SIZE_STRING}.`;
    }

    // if it makes it this far, there is not an error we can detect
    return null;
  };

  validatePreview = (validity, file) => {
    const validationResult = this.validate(validity, file);
    if (validationResult !== null) {
      return this.props.onError(validationResult);
    }
    this.props.onError('');
    // clear the form so that another image can be uploaded
    this.clearForm();
    // send back the validated file
    return this.props.onValidated(file);
  };

  onChange = e => {
    const {
      target: {
        validity,
        files: [file],
      },
    } = e;

    if (!file) return;

    return this.validatePreview(validity, file);
  };

  clearForm = () => {
    if (this.form) {
      this.form.reset();
    }
  };

  componentDidMount() {
    document.addEventListener('paste', this.onPaste, true);
    return this.clearForm();
  }

  componentWillUnmount() {
    document.removeEventListener('paste', this.onPaste);
    return this.clearForm();
  }

  onPaste = event => {
    // Ensure that the image is only pasted if user focuses input
    if (!event || !this.props.inputFocused) {
      return;
    }
    const items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    if (!items) {
      return;
    }
    for (let item of items) {
      if (item.kind === 'file' && item.type.includes('image/')) {
        this.validatePreview({ valid: true }, item.getAsFile());
        break;
      }
    }
  };

  render() {
    const {
      isSendingMediaMessage,
      icon = 'insert-photo',
      color,
      size,
      tooltipContent = 'Upload photo/video',
      accept,
    } = this.props;

    if (isSendingMediaMessage) {
      return (
        <MediaLabel>
          <Loading />
        </MediaLabel>
      );
    }

    return (
      // <Form
      //   // onSubmit={e => e.preventDefault()}
      //   // ref={c => (this.form = c)}
      //   data-cy="chat-input-media-uploader"
      // >
      <Tooltip content={tooltipContent}>
        <MediaLabel>
          <MediaInput
            type="file"
            accept={accept ? accept : '.png, .jpg, .jpeg, .gif, .mp4'}
            multiple={false}
            onChange={this.onChange}
            onClick={event => {
              event.target.value = null;
            }}
          />
          <Icon glyph={icon} color={color} size={size} />
        </MediaLabel>
      </Tooltip>
      // </Form>
    );
  }
}

export default MediaUploader;
